/**
 * desc: 短视频直播列表
 * method: get
 */
import axios from '../../axios'
import UserStore from '@stores/UserStore'

export default {
  // 短视频列表
  queryList: (params: any) => {
    return axios.get(
      '/learn/app/clientapi/live/shortVideo/queryLittleVideoList.do',
      {
        params: { ...params, sortType: 3 },
      }
    )
  },
  // 搜索接口
  searchList: (params: any) => {
    return axios.post(
      '/learn/app/clientapi/live/shortVideo/search/searchByKeyword.do',
      {
        ...params,
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          sid: UserStore.getSid(),
        },
      }
    )
  },
  // 验证是否下架
  queryDetail: (params: any) => {
    return axios.get('/learn/app/clientapi/live/shortVideo/detail.do', {
      params,
    })
  },
  // 上报时长
  reportViewDuration: (params: any) => {
    return axios.post(
      '/learn/app/clientapi/live/shortVideo/reportViewDuration.do',
      {
        ...params,
      }
    )
  },
  // 上报用户已预览小视频
  reportVideoViewRecord: (params: any) => {
    return axios.post(
      '/learn/app/clientapi/live/shortVideo/upSmallVideoViewRecord.do',
      {
        ...params,
      }
    )
  },

  // 上报观看次数
  reportViewTimes: (params: any) => {
    return axios.post(
      '/learn/app/clientapi/live/shortVideo/reportViewTimes.do',
      {
        ...params,
      }
    )
  },
}
